/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

(function () {
  'use strict';

  angular
    .module('service.window-events', [])

    /* @ngInject */
    .service('WindowEventsService', ["$window", function ($window) {

      var api = {
        throttleTime: 200,
        listen: listen,
        fn: {}
      };

      function listen(isOn, type, method, time) {
        var debounceTime = isNaN(time) ? api.throttleTime : time,
          listenerType = isOn ? 'addEventListener' : 'removeEventListener';
        if (isOn) {
          api.fn[method] = _.throttle(method, debounceTime);
        }
        $window[listenerType](type, api.fn[method]);
        if (!isOn) {
          delete api.fn[method];
        }
      }

      return api;

    }]);

})();
